import { BookingFlow } from '@flysas-tech/book-value-stream-models';
import { Boolean, Number, Object, Optional, Record, Static, String } from '@sinclair/typebox';

const RecordType = Record(String(), Record(String(), Boolean()));

export type PopularChoiceConfig = Static<typeof PopularChoiceConfig>;
export const PopularChoiceConfig = Object({
  [BookingFlow.REVENUE]: Optional(RecordType),
  [BookingFlow.AWARD]: Optional(RecordType),
  [BookingFlow.MERGE]: Optional(RecordType),
  [BookingFlow.POINTS]: Optional(RecordType),
  [BookingFlow.CORPORATE]: Optional(RecordType),
  [BookingFlow.REBOOKING]: Optional(RecordType),
  [BookingFlow.TP_TPC]: Optional(RecordType),
});

export type RemoteConfig = Static<typeof RemoteConfig>;
const RemoteConfig = Object({
  popularChoiceConfig: Optional(PopularChoiceConfig),
  overrideDapiWithOneWayDisplay: Optional(Boolean()),
  awardRateLimits: Optional(
    Object({
      FLIGHTS_RATE_LIMIT_MAX: Optional(Number()),
      FLIGHTS_RATE_LIMIT_TIME_WINDOW: Optional(Number()),
      FLIGHTS_RATE_LIMIT_BLOCK_THREASHOLD: Optional(Number()),
      FLIGHTS_EXCESSIVE_RATE_LIMIT_THREASHOLD: Optional(Number()),
      FLIGHTS_EXCESSIVE_RATE_LIMIT_BLOCK_TIME_HOURS: Optional(Number()),
    })
  ),
});
